<div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <h4 class="page-title">Update User</h4>
        </div>
    </div>
</div>

<div class="card">
    <div class="card-body">
        <form [formGroup]="form">
            <div class="mb-3 col-md-4 col-sm-10 col-xs-10">
                <label for="simpleinput" class="form-label">Username</label>
                <input formControlName="username" type="text" id="simpleinput" class="form-control" placeholder="Username">
            </div>
            
            <div class="mb-3 col-md-4 col-sm-10 col-xs-10">
                <label for="example-email" class="form-label">Email</label>
                <input formControlName="email" type="email" id="example-email" name="example-email" class="form-control" placeholder="Email">
            </div>
        </form>

        <div class="row">
            <div class="mb-3 col-md-4 col-sm-10 col-xs-10">
                @if(submitting) {
                    <button class="btn btn-secondary" disabled>
                        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        Submitting...
                    </button>
                } @else {
                    <button class="btn btn-secondary" (click)="updateUser()">
                        Update
                    </button>
                }
                @if(error){<span class="p-2 text-danger">{{error}}</span>}
            </div>
            
        </div>
        <div class="row">
            <div class="mb-3 col-md-4 col-sm-10 col-xs-10">
                @if(resetting) {
                    <button class="btn btn-secondary" disabled>
                        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        Reseting...
                    </button>
                } @else {
                    <button class="btn btn-secondary" (click)="resetPassword()">
                        Reset password
                    </button>
                }
            </div>
        </div>
    </div>
</div>